// Vokabular der Verfügungen, die FÜR einen Kontakt existieren — Abschnitt
// „Vertretung und Bevollmächtigter eines Kontaktes“ der Personenakte.
//
// WARUM KONSTANTE UND NICHT KATALOGTABELLE: Dieselbe Begründung wie bei
// `aoZwecke.ts` und `REGISTER_TYPES` — die Liste steht nicht zur Disposition
// der Anwender. Die sechs Instrumente hat der PO benannt; sie ändern sich durch
// die Rechtslage, nicht durch Admin-Pflege in den Einstellungen. Eine
// Katalogtabelle bräuchte Migration, Seed (der auf PROD ohnehin nur per
// PR-Label liefe), Endpoint und eine Settings-Sektion — für sechs Werte.
//
// Die `code`-Werte sind der Speicherwert (`ContactVerfuegung.art`) und dürfen
// NIE umbenannt werden; die `label` dürfen es. Zeichengleich gespiegelt in
// `apps/api/src/contactVerfuegung.katalog.ts` (Validierung) und im CHECK
// `CHK_ContactVerfuegung_art` der Migration 202608190003.

export type VerfuegungsArt = {
  /** Stabiler Speicherwert. Wandert in `ContactVerfuegung.art`. */
  code: string;
  /** Beschriftung der Ankreuzliste. */
  label: string;
  /** Einzeiler unter der Beschriftung — wofür die Verfügung gilt. */
  hinweis: string;
};

export const VERFUEGUNGS_ARTEN: readonly VerfuegungsArt[] = [
  {
    code: "VORSORGEVOLLMACHT",
    label: "Vorsorgevollmacht",
    hinweis: "Handeln in Vermögens- und Gesundheitsfragen, wenn der Kontakt es selbst nicht mehr kann",
  },
  {
    code: "PATIENTENVERFUEGUNG",
    label: "Patientenverfügung",
    hinweis: "Festlegung zu ärztlichen Maßnahmen (§ 1827 BGB)",
  },
  {
    code: "BETREUUNGSVERFUEGUNG",
    label: "Betreuungsverfügung",
    hinweis: "Wunsch, wen das Betreuungsgericht bestellen soll",
  },
  {
    code: "SORGERECHTSVERFUEGUNG",
    label: "Sorgerechtsverfügung",
    hinweis: "Wer die Kinder betreut, wenn den Eltern etwas zustößt",
  },
  {
    code: "TRAUERVERFUEGUNG",
    label: "Trauerverfügung",
    hinweis: "Bestattungswünsche und wer sie umsetzt",
  },
  {
    code: "TIERVERFUEGUNG",
    label: "Haus- und Großtierverfügung",
    hinweis: "Versorgung von Haustieren, Pferden und Nutztieren",
  },
  {
    code: "TESTAMENT",
    label: "Testament",
    hinweis: "Letztwillige Verfügung — hier einsortiert, nicht in einem eigenen Block",
  },
  {
    // Bank-, Konto- und Depotvollmacht sind in der Praxis EIN Instrument: die
    // Vollmacht gegenüber dem Institut. Drei fast gleiche Haken würden nur die
    // Frage erzeugen, worin der Unterschied liegt.
    code: "BANKVOLLMACHT",
    label: "Bank-, Konto- und Depotvollmacht",
    hinweis: "Verfügung über Konten und Depots bei einem Institut",
  },
  {
    code: "GENERALVOLLMACHT",
    label: "Generalvollmacht",
    hinweis: "Umfassende Vertretung — nicht auf Bankgeschäfte beschränkt",
  },
] as const;

const NACH_CODE = new Map(VERFUEGUNGS_ARTEN.map((a) => [a.code, a]));

/** Beschriftung zu einem gespeicherten Code — unbekannte Codes bleiben sichtbar. */
export const verfuegungArtLabel = (code: string): string =>
  NACH_CODE.get(code)?.label ?? code;

export const istVerfuegungsArt = (code: string): boolean => NACH_CODE.has(code);
